import { Controller } from "@hotwired/stimulus"

// Plan config form controller.
// Maneja el form general de configuración del plan.
// Actualmente es un placeholder para futuras interacciones
// (ej: submit con loading, validaciones client-side).

export default class extends Controller {
  connect() {
    // Placeholder
  }
}
